import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, vModelText as _vModelText, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/imgcaptions/piceBox.png'
import _imports_1 from '@/assets/imgcaptions/icon_tianjiasel.png'


const _hoisted_1 = { class: "exportBox" }
const _hoisted_2 = { class: "exportTitle" }
const _hoisted_3 = { class: "shareExport" }
const _hoisted_4 = { class: "shareExportMain" }
const _hoisted_5 = { class: "shareExportMainInner" }
const _hoisted_6 = { class: "shareExportMain shareExportMainBorder" }
const _hoisted_7 = { class: "shareExportMainInner" }
const _hoisted_8 = {
  src: _imports_1,
  alt: ""
}
const _hoisted_9 = {
  src: _imports_1,
  alt: ""
}
const _hoisted_10 = {
  src: _imports_1,
  alt: ""
}
const _hoisted_11 = { class: "shareExportMain" }

import {
    Close,
} from "@element-plus/icons-vue";
import { ref, onMounted } from 'vue'
import { ElMessage, ElMessageBox, ElLoading } from "element-plus";
import FetchRequest from "@/api/FetchRequest";
import Auth from "@/api/Auth";
import newCaptionApi from "@/api/newCaption/index.ts";
import {captionTtsStore} from "@/store/captionTts.ts"

export default /*@__PURE__*/_defineComponent({
  __name: 'export',
  props: {
    titleText:String,
    id:String,
    },
  emits: ['closeThis','exportFun'],
  setup(__props, { emit: __emit }) {

const token = Auth.getToken();
// 引入接口
const ttstore=captionTtsStore()
const props = __props
const emit = __emit
// 关闭弹窗
const closeBox=()=>{
    emit('closeThis')
}
const checkList=ref(['1'])
const checkListType=ref('srt')
    // 下载
const FilenameTxt=ref('')
    const Filename=ref('')
    const onOff=ref(false)
const downText=()=>{
    if(FilenameTxt.value==''){
        ElMessage.warning('请填写文件名')
        return
    }
    let obj = {
        contents: checkList.value.join(','),
        ext: checkListType.value,
        id:props.id,
    }
    if(onOff.value){
        return
    }
    onOff.value=true
    console.log(checkList.value)
    if(checkListType.value=='xlsx'){
        // console.log('导出excel')
        downExcel(obj,FilenameTxt.value + '.' + obj.ext).then((res)=>{
            // console.log('下载完成')
            emit('closeThis')
        }).catch(()=>{
            emit('closeThis')
        })
       
           
    }else{
        newCaptionApi.TextDownlod(obj.id, obj.contents, obj.ext)
        .then(res => {
            
            Filename.value = decodeURIComponent(res.headers.get('Filename'))
            console.log(res)
            return res.blob()
        })
        .then(data => {
            
            const fileURL = window.URL.createObjectURL(data); // 创建了

            const link = document.createElement('a'); // 创建一个链接元素开

            link.href = fileURL;
            // link.download = props.titleText.split('.')[0] + '.' + Filename.value.split('.')[1];
            // link.download = props.titleText.split('.')[0] + '.' + obj.ext;
            link.download = FilenameTxt.value + '.' + obj.ext;
            
            console.log(Filename.value)
            link.click(); // 拟点击下载链接
            window.URL.revokeObjectURL(fileURL);
            emit('closeThis')
        })
    }
    
}
// 下载excel流文件
const downExcel = async (obj:any,filename:any) => {
    try {
        const response = await fetch(FetchRequest.getHost() +'/ai/subtitle/text/export/excel'+'?textId='+obj.id +'&contents='+obj.contents+'&ext='+obj.ext, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded' ,
            Authorization: "Bearer " + token,
            },
        });
        
        if (!response.ok) {
            throw new Error(`下载失败: ${response.statusText}`);
        }
        
        const blob = await response.blob();
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
        console.error('下载失败:', error);
    }

}

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("span", null, "导出", -1)),
      _createElementVNode("span", {
        class: "closeBtn",
        onClick: _withModifiers(closeBox, ["stop"])
      }, [
        _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [
            _createVNode(_unref(Close))
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "shareExportMainTitle" }, "字幕内容", -1)),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_checkbox_group, {
            modelValue: checkList.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((checkList).value = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_checkbox, {
                label: "原文",
                value: "1"
              }),
              _withDirectives(_createVNode(_component_el_checkbox, {
                label: "译文",
                value: "2"
              }, null, 512), [
                [_vShow, _unref(ttstore).isHaveTranslation]
              ])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "shareExportMainTitle" }, "文件格式", -1)),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("img", {
              src: _imports_0,
              alt: "",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (checkListType.value='srt'), ["stop"]))
            }, null, 512), [
              [_vShow, checkListType.value!='srt']
            ]),
            _withDirectives(_createElementVNode("img", _hoisted_8, null, 512), [
              [_vShow, checkListType.value=='srt']
            ]),
            _createElementVNode("span", {
              style: _normalizeStyle(checkListType.value=='srt'?{'color':'#409eff'}: '')
            }, "srt", 4)
          ]),
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("img", {
              src: _imports_0,
              alt: "",
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (checkListType.value='txt'), ["stop"]))
            }, null, 512), [
              [_vShow, checkListType.value!='txt']
            ]),
            _withDirectives(_createElementVNode("img", _hoisted_9, null, 512), [
              [_vShow, checkListType.value=='txt']
            ]),
            _createElementVNode("span", {
              style: _normalizeStyle(checkListType.value=='txt'?{'color':'#409eff'}: '')
            }, "txt", 4)
          ]),
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("img", {
              src: _imports_0,
              alt: "",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (checkListType.value='xlsx'), ["stop"]))
            }, null, 512), [
              [_vShow, checkListType.value!='xlsx']
            ]),
            _withDirectives(_createElementVNode("img", _hoisted_10, null, 512), [
              [_vShow, checkListType.value=='xlsx']
            ]),
            _createElementVNode("span", {
              style: _normalizeStyle(checkListType.value=='xlsx'?{'color':'#409eff'}: '')
            }, "excel", 4)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "shareExportMainTitle" }, "文件名称", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          placeholder: "请输入文件名称",
          class: "shareExportMainInput",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((FilenameTxt).value = $event))
        }, null, 512), [
          [_vModelText, FilenameTxt.value]
        ])
      ]),
      _createVNode(_component_el_button, {
        type: "primary",
        style: {"width":"100%"},
        size: "small",
        color: "#207CF6 ",
        onClick: _withModifiers(downText, ["stop"])
      }, {
        default: _withCtx(() => _cache[9] || (_cache[9] = [
          _createTextVNode("下载")
        ])),
        _: 1
      })
    ])
  ]))
}
}

})